import a from './contact-channels198.js';

var l=/(\$\d)/;function u(n,a$1,t){var r=t.useInternationalFormat,i=t.withNationalPrefix;t.carrierCode,t.metadata;var e=n.replace(new RegExp(a$1.pattern()),r?a$1.internationalFormat():i&&a$1.nationalPrefixFormattingRule()?a$1.format().replace(l,a$1.nationalPrefixFormattingRule()):a$1.format());return r?a(e):e}

export { l as FIRST_GROUP_PATTERN, u as default };
//# sourceMappingURL=contact-channels196.js.map
